var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 gift-cart-contents"},_vm._l((_vm.cartProductContents),function(cartProduct,index){return _c('adv-cart-gift-row',{key:index,attrs:{"mini-cart":_vm.miniCart,"cart-product":cartProduct}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }